import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useLanguage } from "@/contexts/LanguageContext";

interface NavigationItem {
  id: string;
  language_code: string;
  name: string;
  href: string;
  sort_order: number;
  is_active: boolean;
}

export const useNavigation = () => {
  const { currentLanguage } = useLanguage();

  return useQuery({
    queryKey: ["navigation", currentLanguage],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("navigation_items")
        .select("*")
        .eq("language_code", currentLanguage)
        .eq("is_active", true)
        .order("sort_order");

      if (error) throw error;
      return data as NavigationItem[];
    },
  });
};

export const useAllNavigation = () => {
  return useQuery({
    queryKey: ["navigation-all"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("navigation_items")
        .select("*")
        .order("language_code")
        .order("sort_order");

      if (error) throw error;
      return data as NavigationItem[];
    },
  });
};
